import { parseQueryString } from '@bit/streamline.web.utils'
import http from '../http'
import axios from 'axios'

export default {
  checkAuthenticated (context) {
    let token = {}
    // Check if login hash exists, log in manually if true
    if (context.$route.hash.length > 5) {
      token = parseQueryString(context.$route.hash.substring(1).replace(/[$]/, ''))
      context.$localStorage.set('access_token', token.access_token)
    }
    else if (context.$localStorage.get('access_token')) {
      token.access_token = context.$localStorage.get('access_token')
    }

    if (token) {
      context.$auth.token(null, token.access_token)
      http.axios.defaults.headers.common.Authorization = 'Bearer ' + token.access_token
      axios.defaults.headers.common.Authorization = 'Bearer ' + token.access_token
      context.$http.get('user/me').then((response) => {
        context.$auth.watch.data = response.data // access_token ???
        context.$auth.watch.loaded = true
        context.$auth.watch.authenticated = true
        context.$auth.user(response.data)

        const redirect = context.$auth.redirect()

        if (redirect) {
          context.$router.push({ name: redirect.from.name, params: { id: redirect.from.params.id } })
        }
      })
    }
  }
}
